/* ==========================================================
   LUI · Página Protocolo con oferta
   Toggle suscripción / compra única · tiers 1-3-6 · complemento
   ========================================================== */
(function () {
  'use strict';

  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function fmt(n) {
    n = Math.round(n);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) left--; /* no cuenta domingos */
    }
    return d;
  }

  function dateRange(minDays, maxDays) {
    var now = new Date();
    var a = addBusinessDays(now, minDays);
    var b = addBusinessDays(now, maxDays);
    if (a.getMonth() === b.getMonth()) {
      return 'entre el ' + a.getDate() + ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()];
    }
    return 'entre el ' + a.getDate() + ' de ' + MESES[a.getMonth()] + ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()];
  }

  function boot(root) {
    if (!root || root.dataset.lprReady === '1') return;
    root.dataset.lprReady = '1';

    var data = {};
    try { data = JSON.parse(root.querySelector('[data-lpr-data]').textContent); } catch (e) { return; }

    var hasSub = !!data.sub_plan;
    var state = {
      mode: hasSub ? 'sub' : 'once',
      qty: parseInt(data.default_qty || '3', 10),
      addon: false
    };

    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function setText(sel, v) { qa(sel).forEach(function (el) { el.textContent = v; }); }

    /* ---------- Fechas de entrega ---------- */
    (function () {
      var txt = dateRange(parseInt(data.ship_min || '3', 10), parseInt(data.ship_max || '6', 10));
      setText('[data-lpr-dates]', txt);
    })();

    /* ---------- Galería ---------- */
    (function () {
      var slides = qa('[data-lpr-slide]');
      var thumbs = qa('[data-lpr-thumb]');
      if (!slides.length) return;
      function go(i) {
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var main = q('[data-lpr-gallery]');
      var cur = 0;
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 44) {
            cur = (cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
            go(cur);
          }
          x0 = null;
        }, { passive: true });
        thumbs.forEach(function (t, k) { t.addEventListener('click', function () { cur = k; }); });
      }
      go(0);
    })();

    /* ---------- Precios ---------- */
    function pct(qty) {
      var m = state.mode === 'sub' ? data.sub_pct : data.once_pct;
      return parseFloat((m && m[qty]) || 0);
    }
    function tierPrice(qty) {
      var full = data.unit * qty;
      return Math.round(full * (1 - pct(qty) / 100));
    }
    function total() {
      return tierPrice(state.qty) + (state.addon ? data.addon_price : 0);
    }
    function code() {
      var key = (state.mode === 'sub' ? 'sub' : 'once') + state.qty + (state.addon ? 's' : '');
      return (data.codes && data.codes[key]) || '';
    }

    function render() {
      var isSub = state.mode === 'sub';
      qa('[data-lpr-mode]').forEach(function (b) {
        var on = b.dataset.lprMode === state.mode;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
      setText('[data-lpr-mode-note]', isSub ? data.note_sub : data.note_once);

      qa('[data-lpr-tier]').forEach(function (t) {
        var qty = parseInt(t.dataset.lprTier, 10);
        var on = qty === state.qty;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', String(on));
        var p = pct(qty);
        var price = tierPrice(qty);
        var elP = t.querySelector('[data-lpr-t-price]');
        var elC = t.querySelector('[data-lpr-t-compare]');
        var elU = t.querySelector('[data-lpr-t-unit]');
        var elS = t.querySelector('[data-lpr-t-save]');
        if (elP) elP.textContent = fmt(price);
        if (elC) elC.textContent = p > 0 ? fmt(data.unit * qty) : '';
        if (elU) elU.textContent = fmt(price / qty) + ' ' + (data.per_unit_label || 'por frasco');
        var saved = data.unit * qty - price;
        if (elS) {
          elS.textContent = p > 0 ? (data.save_label || 'Ahorras') + ' ' + fmt(saved) + ' (' + Math.round(p) + '%)' : (data.regular_label || 'Precio regular');
          elS.classList.toggle('is-regular', !(p > 0));
        }
      });

      var box = q('[data-lpr-addon-box]');
      if (box) box.classList.toggle('is-on', state.addon);

      var t = fmt(total());
      setText('[data-lpr-total]', t);
      setText('[data-lpr-cta-label]', (data.cta_label || 'Agregar al carrito') + ' · ' + t);
      var stickySub = q('[data-lpr-sticky-sub]');
      if (stickySub) {
        var tierName = (data.tier_names && data.tier_names[state.qty]) || (state.qty + ' frascos');
        stickySub.textContent = tierName + (isSub ? ' · ' + (data.sub_short || 'suscripción') : '') + (state.addon ? ' + shampoo' : '');
      }
    }

    qa('[data-lpr-mode]').forEach(function (b) {
      b.addEventListener('click', function () { state.mode = b.dataset.lprMode; render(); });
    });
    qa('[data-lpr-tier]').forEach(function (t) {
      t.addEventListener('click', function () { state.qty = parseInt(t.dataset.lprTier, 10); render(); });
    });
    var chk = q('[data-lpr-addon]');
    if (chk) chk.addEventListener('change', function () { state.addon = chk.checked; render(); });

    /* ---------- Ver más reseñas ---------- */
    (function () {
      var btn = q('[data-lpr-more]');
      var extra = qa('[data-lpr-review-extra]');
      if (!btn || !extra.length) { if (btn) btn.style.display = 'none'; return; }
      var open = false;
      btn.addEventListener('click', function () {
        open = !open;
        extra.forEach(function (r) { r.classList.toggle('is-hidden', !open); });
        btn.textContent = open ? (data.less_label || 'Ver menos reseñas') : (data.more_label || 'Ver más reseñas');
        if (!open) {
          var grid = q('[data-lpr-rgrid]');
          if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    })();

    /* ---------- Agregar al carrito ---------- */
    function showErr(msg) {
      var el = q('[data-lpr-err]');
      if (!el) { alert(msg); return; }
      el.textContent = msg;
      el.classList.add('is-on');
    }

    function addToCart(e) {
      e.preventDefault();
      var btns = qa('[data-lpr-cta]');
      btns.forEach(function (b) { b.disabled = true; });
      var label = q('[data-lpr-cta-label]');
      var prev = label ? label.textContent : '';
      setText('[data-lpr-cta-label]', data.adding_label || 'Agregando...');

      var main = { id: Number(data.variant_id), quantity: state.qty };
      if (state.mode === 'sub' && data.sub_plan) main.selling_plan = Number(data.sub_plan);
      var items = [main];
      if (state.addon && data.addon_variant_id) items.push({ id: Number(data.addon_variant_id), quantity: 1 });

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'No se pudo agregar');
          var c = code();
          window.location.href = c
            ? '/discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent('/checkout')
            : '/checkout';
        })
        .catch(function (err) {
          btns.forEach(function (b) { b.disabled = false; });
          setText('[data-lpr-cta-label]', prev);
          showErr('No pudimos agregar tu pedido: ' + err.message);
        });
    }
    qa('[data-lpr-cta]').forEach(function (b) { b.addEventListener('click', addToCart); });

    /* ---------- Sticky móvil ---------- */
    (function () {
      var bar = q('[data-lpr-sticky]');
      var anchor = q('[data-lpr-buybox]');
      var end = q('[data-lpr-footer]');
      if (!bar || !anchor) return;
      var last = 0;
      function update() {
        last = Date.now();
        var passed = anchor.getBoundingClientRect().bottom < 0;
        var atEnd = end ? end.getBoundingClientRect().top < window.innerHeight : false;
        bar.classList.toggle('is-on', passed && !atEnd);
      }
      window.addEventListener('scroll', function () { if (Date.now() - last > 80) update(); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    })();

    /* ---------- Nav suave ---------- */
    qa('[data-lpr-nav] a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    render();
  }

  function init() { document.querySelectorAll('[data-lpr-root]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
